import { render } from "./history-tab-groups.vue?vue&type=template&id=07f2710d"
import script from "./history-tab-groups.vue?vue&type=script&setup=true&lang=js"
export * from "./history-tab-groups.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/history/history-card/components/history-tab-groups.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07f2710d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07f2710d', __exports__)) {
    api.reload('07f2710d', __exports__)
  }
  
  module.hot.accept("./history-tab-groups.vue?vue&type=template&id=07f2710d", () => {
    api.rerender('07f2710d', render)
  })

}


export default __exports__